import { ApiError } from '@/services/api';
import * as E from 'fp-ts/Either';
import * as TE from 'fp-ts/lib/TaskEither';

export const taskToPromise = async <T, A extends any[]>(task: (...args: A) => TE.TaskEither<ApiError, T>, ...args: A): Promise<T> => {
  const resultEither = await task.call(null, ...args)();
  return E.getOrElse<ApiError, T>(error => {
    throw error;
  })(resultEither);
};
